import { crudService } from '../_services/'
import { toast } from 'react-toastify'
import { stringUtils } from 'utils'

export const obraDiarioAction = {
  getObraDiario,
  getObraDiarioById,
  onChangeProps,
  createObraDiario,
  deleteObraDiarioById,
  clear,
  clearDetail
}

function getObraDiario(filterModel) {
  return (dispatch) => {
    let apiEndpoint = 'obrasDiarios' + stringUtils.serialize(filterModel);
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeObraDiariosList(response.data.items, response.data.totalRows))
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

function createObraDiario(payload) {
  return (dispatch) => {
    dispatch(isLoading())
    dispatch(request(payload))
    let apiEndpoint = 'obrasDiarios'
    crudService
      .post(apiEndpoint, payload)
      .then((response) => {
        if (response.request != undefined && response.request.status === 200) {
          toast.success('Feito! Cadastro realizado com sucesso!')

          dispatch(clear())
          dispatch(notIsLoading())

          let filterModel = {
            IdObra: payload.idObra
          };

          dispatch(getObraDiario(filterModel, true));

        } else {
          let filterModel = {
            IdObra: payload.idObra
          };

          dispatch(getObraDiario(filterModel, true));
        }
      })
      .catch((err) => {
        // console.log('err', err)
        dispatch(failure(err))
        dispatch(notIsLoading())
      })
  }

  function request(payload) {
    return { type: 'CREATE_OBRA_DIARIO_REQUEST', payload }
  }

  function failure(error) {
    return { type: 'CREATE_OBRA_DIARIO_FAILURE', error }
  }
}

export function clear() {
  return {
    type: 'OBRA_DIARIO_CLEAR'
  }
}

export function clearDetail() {
  return {
    type: 'OBRA_DIARIO_CLEAR_DETAIL'
  }
}

function getObraDiarioById(id) {
  return (dispatch) => {
    let apiEndpoint = 'obrasDiarios/' + id
    crudService.get(apiEndpoint).then((response) => {
      dispatch(editObraDiariosDetails(response.data))
    })
  }
}

function onChangeProps(props, event) {
  return (dispatch) => {
    if (props === 'imagem') {
      dispatch(handleOnChangeProps(props, event))
    } else {
      dispatch(handleOnChangeProps(props, event.target.value))
    }
  }
}

function deleteObraDiarioById(id, idObra) {
  return (dispatch) => {
    dispatch(isLoading())
    let apiEndpoint = 'obrasDiarios/' + id
    crudService.deleteDetail(apiEndpoint).then((response) => {
      dispatch(deleteObraDiariosDetails())
      dispatch(notIsLoading())

      let filterModel = {
        IdObra: idObra
      };

      dispatch(getObraDiario(filterModel, true));
    })
  }
}
export function changeObraDiariosList(obraDiario, totalRows) {
  return {
    type: 'FETCHED_ALL_OBRA_DIARIO',
    obraDiario: obraDiario,
    totalRegistros: totalRows
  }
}
export function handleOnChangeProps(props, value) {
  return {
    type: 'OBRA_DIARIO_HANDLE_ON_CHANGE',
    props: props,
    value: value
  }
}
export function editObraDiariosDetails(obraDiario) {
  return {
    type: 'OBRA_DIARIO_DETAIL',
    id: obraDiario.id,
    idObra: obraDiario.idObra,
    idEmpresa: obraDiario.idEmpresa,
    data: obraDiario.data,
    condicaoClimatica: obraDiario.condicaoClimatica,
    responsavelTecnico: obraDiario.responsavelTecnico,
    obra: obraDiario.obra,
    empresa: obraDiario.empresa,
    obrasDiariosAnexos: obraDiario.obrasDiariosAnexos,
    obrasDiariosEquipes: obraDiario.obrasDiariosEquipes
  }
}
export function createUserInfo() {
  return {
    type: 'OBRA_DIARIO_CREATED_SUCCESSFULLY'
  }
}
export function deleteObraDiariosDetails() {
  return {
    type: 'DELETED_OBRA_DIARIO_DETAILS'
  }
}
export function isLoading() {
  return {
    type: 'OBRA_DIARIO_ISLOADING'
  }
}

export function notIsLoading() {
  return {
    type: 'OBRA_DIARIO_NOTISLOADING'
  }
}

